module.exports = __webpack_public_path__ + "static/media/bell_default.d087f155.svg";